import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import Actions from '../../../../actions'
import Selectors from '../../../../selectors'
import dayjs from 'dayjs'
import { isBrowser, isTablet } from 'react-device-detect'
import { gaEvent } from '../../../../common/services/analytics'
import { getNominative } from '../../../../common/utils'
import { colors, sizes } from '@lmc/common/constants'
import { Spinner, SeenByList } from '../../../../components/generic'
import RiskAssessmentItem from '../../../Residents/screens/ResidentRiskAssessmentsScreens/components/RiskAssessmentItem'
import {
  CarePlanNextReviewField,
  CarePlanSummaryHeader,
  CarePlanSectionContent,
  CarePlanAction,
  CarePlanSectionHeader,
  CarePlanDocuments,
} from '../../../../components/carePlans'
import Signatures from '../../components/CarePlanSignatures'
import {
  ButtonOLD,
  EmptyState,
  NotStartedIcon,
  FormCard,
  Heading,
} from '@lmc/ui-kit'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'
import { Badge } from '@lmc/ui-kit'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { getNeedsAndSkillsTemplates } from 'selectors/NeedsAndSkills'
import CarePlanGoalsListInput from './components/CarePlansGoalsListInput/CarePlanGoalsListInput'
import { CarePlanSectionContainer } from '../../components/CarePlanSections'
import { CAREPLAN_ADL_PBS_ID } from '@lmc/common/types'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'

export class CarePlanViewScreen extends React.Component {
  form = null

  setFormRef = (node) => (this.form = node)

  componentDidMount() {
    const {
      features,
      fetchData,
      fetchNeedsOptions,
      fetchSkillNeedTemplates,
      carePlan,
      router: {
        params: { id, care_plan_id, revision_id },
      },
    } = this.props

    const chosenId = revision_id || care_plan_id
    if (chosenId && id) fetchData({ carePlan: chosenId, resident: id })
    if (carePlan) this.triggerGAEvent()
    if (features?.features?.skillsAndNeeds?.enabled) {
      fetchNeedsOptions?.()
      fetchSkillNeedTemplates?.()
    }
  }

  componentDidUpdate(prew) {
    const { carePlan } = this.props
    if (carePlan && !prew.carePlan) this.triggerGAEvent()
  }

  triggerGAEvent() {
    gaEvent({
      category: 'CarePlans',
      action: `View`,
      label: this.props.carePlan.carePlanAdl.name,
    })
  }

  handleRiskAssessmentClick = (id) => {
    const {
      router: { params },
    } = this.props

    this.form?.scrollIntoView()
    window.scrollTo(0, 0)

    history.push(`/residents/${params.id}/risk-assessments/${id}`)
  }

  onEdit = () => {
    const {
      router: {
        params: { id, care_plan_id },
      },
      carePlan,
    } = this.props

    gaEvent({
      category: 'CarePlans',
      action: `Edit`,
      label: carePlan.carePlanAdl.name,
    })

    history.push(`/residents/${id}/care-plans/${care_plan_id}/edit`)
  }

  renderHeader = (carePlan) => {
    const {
      router: {
        params: { id, care_plan_id },
      },
      residents,
      logs,
      carePlanNominative,
    } = this.props

    const resident = _.find(residents, { id })
    const baseUrl = `/residents/${id}/care-plans`

    return (
      <CarePlanSummaryHeader
        carePlan={carePlan}
        carer={carePlan.editedBy}
        resident={resident}
        logs={logs}
        onClickBack={() => history.push(baseUrl)}
        onClickHistory={() =>
          history.push(`${baseUrl}/${care_plan_id}/history`)
        }
        carePlanNominative={carePlanNominative}
      />
    )
  }

  renderRisks = () => {
    const { carePlan, carePlanNominative } = this.props
    const { riskAssessments } = carePlan

    let Risks = null

    if (riskAssessments && riskAssessments.length) {
      Risks = _.sortBy(riskAssessments, 'form.name').map((row) => {
        const hasActions = !!row?.form?.hasActions && !!row?.formData?.actions

        return (
          <>
            <RiskAssessmentItem
              carer={row.createdBy}
              key={row.id}
              showUpdateAlert={dayjs(carePlan.editedOn).isBefore(row.createdOn)}
              riskAssessment={row}
              onView={this.handleRiskAssessmentClick}
              carePlanNominative={carePlanNominative}
            />
            {hasActions && (
              <WrapperActions>
                <StyledHeading level={3}>
                  Actions for {row?.form?.name}
                </StyledHeading>
                <StyledText>{row?.formData?.actions}</StyledText>
              </WrapperActions>
            )}
          </>
        )
      })
    }

    const hasRisks = !!Risks?.length

    return (
      <div style={styles.sectionContainer}>
        <FormCard title="Risks">
          {hasRisks ? <div style={styles.risksSection}>{Risks}</div> : null}
        </FormCard>
      </div>
    )
  }

  getActions = (riskAssessments) => {
    if (
      !riskAssessments ||
      !riskAssessments.length ||
      _.some(riskAssessments, (assessment) => !assessment.formData) ||
      _.every(
        riskAssessments,
        (assessment) => !assessment.formData || !assessment.formData.actions
      )
    ) {
      return null
    }
    return riskAssessments.map((row) => {
      if (!row.formData.actions) return null
      return (
        <CarePlanAction
          key={row.id}
          title={row.form.name}
          text={row.formData.actions}
        />
      )
    })
  }

  renderActions = () => {
    const {
      carePlan: { riskAssessments },
    } = this.props
    const Actions = this.getActions(riskAssessments)
    return (
      <div style={styles.sectionContainer}>
        <CarePlanSectionHeader
          color={colors.blue}
          icon="calendar"
          title="Risk related actions"
        />
        <div style={styles.actionsSection}>
          {Actions && Actions.length ? (
            <div className="lmc-card">{Actions}</div>
          ) : (
            <EmptyState
              title={NO_ACTIONS_HEADING}
              description={NO_ACTIONS_NOTE}
              icon={<NotStartedIcon />}
            >
              <a href={SUPPORT_ARTICLE} rel="noreferrer" target="_blank">
                Find out more
              </a>
            </EmptyState>
          )}
        </div>
      </div>
    )
  }

  renderDocuments = () => {
    const { carePlan, documents } = this.props
    return (
      <div style={styles.sectionContainer}>
        <CarePlanDocuments carePlan={carePlan} documents={documents} />
      </div>
    )
  }

  renderNextReview = (carePlan) => (
    <div style={styles.sectionContainer}>
      <CarePlanNextReviewField
        date={carePlan.nextReviewDate}
        noFurtherSupportRequired={carePlan.noFurtherSupportRequired}
        style={{
          marginBottom: 25,
          marginTop: 25,
        }}
      />
    </div>
  )

  renderSeenBy = (seenBy) => {
    if (!seenBy) return null
    return <SeenByList seenBy={seenBy} />
  }

  // TODO once component is refactored change it to useSkillsAndNeedsTemplate
  link = () => {
    // eslint-disable-next-line react/prop-types
    const { skillNeedTemplates, home, user } = this.props

    const hasTemplates = skillNeedTemplates && skillNeedTemplates?.length > 0

    if (hasTemplates) {
      return undefined
    }

    // eslint-disable-next-line react/prop-types
    const homeGroup = home?.homeGroup

    const isHomeGroup = !!homeGroup

    const role = user?.role

    const roleWhoCanEditSkillsAndNeedsTemplate = isHomeGroup
      ? 'group-admin'
      : 'carehome-admin'

    const hasPermisionToAddSkillsOrNeedsTemplate =
      // eslint-disable-next-line react/prop-types
      roleWhoCanEditSkillsAndNeedsTemplate === role

    if (hasPermisionToAddSkillsOrNeedsTemplate) {
      return (
        <Link to="/settings/skills-and-needs">Needs and skills Template</Link>
      )
    }

    return undefined
  }

  renderText = () => {
    const { home, user, skillNeedTemplates } = this.props

    const hasTemplates = skillNeedTemplates && skillNeedTemplates?.length > 0

    if (hasTemplates) {
      return undefined
    }

    const homeGroup = home?.homeGroup

    const isHomeGroup = !!homeGroup

    const role = user?.role

    const roleWhoCanEditSkillsAndNeedsTemplate = isHomeGroup
      ? 'group-admin'
      : 'carehome-admin'

    const hasPermisionToAddSkillsOrNeedsTemplate =
      // eslint-disable-next-line react/prop-types
      roleWhoCanEditSkillsAndNeedsTemplate === role

    if (hasPermisionToAddSkillsOrNeedsTemplate) {
      return 'No needs added to the template. To add new needs, go to '
    }

    return 'No Needs added to the template. To add needs, please contact your group admin.'
  }

  render() {
    const {
      router: {
        params: { id },
      },
      carePlan,
      signatureItem,
      carers,
      logs,
      setLoadedListItem,
      carePlanSignatures,
      documents,
      residents,
      carePlanNominative,
      needsOptions,
      features,
      hasGoals,
      pbsFlagEnabled,
      hasAccess,
    } = this.props

    if (!id || !carePlan || !carers || !documents || !residents) {
      return <Spinner />
    }

    const preferredCarePlanName = getNominative(carePlanNominative, 'Care Plan')

    const skillNeeds = carePlan?.skillNeeds

    const isPBSAssessment =
      pbsFlagEnabled && carePlan.carePlanAdl.id === CAREPLAN_ADL_PBS_ID

    const hasRolePermission = hasAccess(
      ['carehome-admin', 'senior-carer'],
      [
        {
          i: 'update',
          this: 'CarePlan',
        },
      ]
    )

    return (
      <div ref={this.setFormRef} style={styles.wrapper}>
        {this.renderHeader(carePlan)}
        {isPBSAssessment && (
          <CarePlanSectionContainer sections={carePlan?.sections} isVieMode />
        )}
        {!isPBSAssessment && (
          <Section
            color={colors.green}
            icon="calendar"
            title="Strengths"
            content={carePlan.strengths}
          />
        )}
        {!isPBSAssessment && (
          <Section
            color={colors.orange}
            icon="calendar"
            title="Needs"
            content={carePlan.needs}
            innerComponent={
              features?.features?.skillsAndNeeds?.enabled &&
              skillNeeds?.length ? (
                <div style={styles.needItem}>
                  {skillNeeds.map((skillNeed) => (
                    <Badge
                      color={colors.gray}
                      text={
                        needsOptions?.find(
                          (needOption) => needOption.id === skillNeed
                        )?.name
                      }
                      textColor={colors.white}
                      style={{
                        maxWidth: 'fit-content',
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    />
                  ))}
                </div>
              ) : null
            }
          />
        )}
        {this.renderRisks()}
        {hasGoals && (
          <CarePlanGoalsListInput disabled value={carePlan.goals || []} />
        )}
        {this.renderDocuments()}
        {this.renderNextReview(carePlan)}
        {carePlanSignatures && signatureItem && (
          <Signatures
            carePlan={carePlan}
            logs={logs}
            resident={_.find(residents, { id })}
            setLoadedListItem={setLoadedListItem}
            preferredCarePlanName={preferredCarePlanName}
            item={signatureItem.id}
            category={signatureItem.category}
          />
        )}
        {this.renderSeenBy(carePlan.seenBy)}
        {!carePlan.isRevision && (
          <div
            className="lmc-fixed-footer"
            style={{
              ...styles.footer,
              width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
            }}
          >
            <ButtonOLD
              id="review-care-plan"
              dataTestId="cp-review"
              onClick={this.onEdit}
              style={styles.updateButton}
              type="primary"
              disabledByPermission={!hasRolePermission}
            >
              {`Review ${preferredCarePlanName}`}
            </ButtonOLD>
          </div>
        )}
      </div>
    )
  }
}

const NO_ACTIONS_HEADING = 'Complete Risk Assessments to show Actions'
const NO_ACTIONS_NOTE =
  'Actions will show here from the "Actions to mitigate this risk" box within a Risk Assessment.'
const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3353756-how-to-populate-actions-in-a-care-plan'

const Section = ({ color, icon, title, content, innerComponent }) => (
  <div style={styles.sectionContainer}>
    <CarePlanSectionHeader color={color} icon={icon} title={title} />
    <div
      style={{
        ...styles.innerSectionContainer,
        background: !innerComponent ? 'transparent' : 'white',
      }}
    >
      {innerComponent}
      <CarePlanSectionContent value={content} />
    </div>
  </div>
)

const styles = {
  innerSectionContainer: {
    borderRadius: 15,
  },
  needItem: {
    marginLeft: 15,
    paddingTop: 15,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  needTextItem: { color: colors.black, marginBottom: 0 },
  wrapper: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingTop: 24,
    paddingBottom: 80,
  },
  editButton: {
    float: 'right',
  },
  divider: {
    display: 'flex',
    height: 2,
  },
  footer: {
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  subHeading: {
    fontSize: 16,
    opacity: 0.8,
  },
  sectionContainer: {
    paddingTop: 30,
  },
  sectionContent: {
    paddingTop: 15,
    minHeight: 100,
    whiteSpace: 'pre-wrap',
  },
  actionsSection: {
    paddingTop: 15,
    minHeight: 100,
    whiteSpace: 'pre-wrap',
  },
  risksSection: {
    paddingTop: 5,
    minHeight: 100,
  },
  updateButton: {
    color: 'white',
    padding: '0px 25px',
    textShadow: 'none',
  },
}

const WrapperActions = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  padding: 24px;
  background-color: ${(props) => props.theme.color.neutral.color10};
  border-radius: 15px;
`

const StyledHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color4};
  border-bottom: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color8};
  margin-bottom: 10px;
  padding-bottom: 10px;
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
  white-space: pre-wrap;
`

const mapStateToProps = (state, props) => ({
  carePlan: Selectors.getCarePlan(state, props),
  logs: Selectors.getCarePlanLogs(state, props),
  documents: state.data.documents,
  riskAssessments: state.data['risk-assessments'],
  carers: state.data.carers,
  signatureItem: _.find(state.data['log-category-items'], {
    itemId: 'signature',
  }),
  carePlanSignatures: state.global.home.features?.carePlanSignatures?.enabled,
  residents: state.data.residents,
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  needsOptions: state.data['skill-need-templates/needs'],
  features: state.global.home,
  skillNeedTemplates: getNeedsAndSkillsTemplates(state),
  home: state.global.home,
  user: state.global.user,
  hasGoals: state.global.home.features?.goals?.enabled,
  hasAccess: (roles, abilities) =>
    Selectors.checkRoleAccess(state, { roles, abilities }),
})

const mapDispatchToProps = (dispatch) => ({
  setLoadedListItem: (listId, item) =>
    dispatch(Actions.setLoadedListItem(listId, item)),
  fetchData: ({ carePlan, resident }) => {
    dispatch(
      Operations.loadList('risk-assessments', { carePlan, withFormData: true })
    )
    dispatch(Operations.loadList('logs', { carePlanId: carePlan }))
    dispatch(Operations.loadListItem('care-plans', carePlan))
    dispatch(Operations.loadList('documents', { resident }))
  },
  fetchNeedsOptions: () =>
    dispatch(Operations.loadList('skill-need-templates/needs')),
  fetchSkillNeedTemplates: () =>
    dispatch(Operations.loadList('skill-need-templates')),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(CarePlanViewScreen))
)
